import DeletedIcon from '../../../img/delete.svg?react';
import styles from './styles.module.scss';

function DeletedMessage() {
  return (
    <div className={styles.txtMsgBodyDeleted}>
      <DeletedIcon />
      Nachricht wurde gelöscht.
    </div>
  );
}

export default DeletedMessage;
